var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("apps.hrm.message.general") }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-6" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.hrm.message.fullname") + " *" }
                  }),
                  _vm._v(" "),
                  _c("BaseInput", {
                    attrs: {
                      classNames: [{ "is-invalid": _vm.$v.input.name.$error }],
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.$v.input.name.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.input.name, "$model", $$v)
                      },
                      expression: "$v.input.name.$model"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { className: "col-lg-2" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.hrm.message.gender") }
                  }),
                  _vm._v(" "),
                  _c("BaseDropdown", {
                    attrs: {
                      options: _vm.genderOptions,
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.input.gender,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "gender", $$v)
                      },
                      expression: "input.gender"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { className: "col-lg-2" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.hrm.message.birthdate") }
                  }),
                  _vm._v(" "),
                  _c("BaseInputDatePicker", {
                    attrs: { disabled: _vm.disabled },
                    model: {
                      value: _vm.input.birthdate,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "birthdate", $$v)
                      },
                      expression: "input.birthdate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-3" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.hrm.message.department") }
                  }),
                  _vm._v(" "),
                  _c("BaseDropdown", {
                    attrs: {
                      options: _vm.departmentOptions,
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.input.departmentId,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "departmentId", $$v)
                      },
                      expression: "input.departmentId"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { className: "col-lg-3" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.hrm.message.position") }
                  }),
                  _vm._v(" "),
                  _c("BaseDropdown", {
                    attrs: {
                      options: _vm.positionOptions,
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.input.positionId,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "positionId", $$v)
                      },
                      expression: "input.positionId"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("apps.hrm.message.contacts") }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-3" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.hrm.message.tel") }
                  }),
                  _vm._v(" "),
                  _c("BaseInput", {
                    attrs: { disabled: _vm.disabled },
                    model: {
                      value: _vm.input.tel,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "tel", $$v)
                      },
                      expression: "input.tel"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { className: "col-lg-3" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.hrm.message.email") }
                  }),
                  _vm._v(" "),
                  _c("BaseInput", {
                    attrs: { disabled: _vm.disabled },
                    model: {
                      value: _vm.input.email,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "email", $$v)
                      },
                      expression: "input.email"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-6" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.hrm.message.address") }
                  }),
                  _vm._v(" "),
                  _c("BaseTextArea", {
                    attrs: { disabled: _vm.disabled, rows: 3 },
                    model: {
                      value: _vm.input.address,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "address", $$v)
                      },
                      expression: "input.address"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("apps.hrm.message.userinfoincompany") }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-2" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.hrm.message.wageamount") }
                  }),
                  _vm._v(" "),
                  _c("BaseInputNumber", {
                    attrs: { disabled: _vm.disabled },
                    model: {
                      value: _vm.input.wageAmount,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "wageAmount", $$v)
                      },
                      expression: "input.wageAmount"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { className: "col-lg-2" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.hrm.message.wagetype") }
                  }),
                  _vm._v(" "),
                  _c("BaseDropdown", {
                    attrs: { options: _vm.wageOptions, disabled: _vm.disabled },
                    model: {
                      value: _vm.input.wageType,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "wageType", $$v)
                      },
                      expression: "input.wageType"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-2" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.hrm.message.startworkingdate") }
                  }),
                  _vm._v(" "),
                  _c("BaseInputDatePicker", {
                    attrs: { disabled: _vm.disabled },
                    model: {
                      value: _vm.input.startWorkingDate,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "startWorkingDate", $$v)
                      },
                      expression: "input.startWorkingDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-6" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.hrm.message.note") }
                  }),
                  _vm._v(" "),
                  _c("BaseTextArea", {
                    attrs: { disabled: _vm.disabled, rows: 3 },
                    model: {
                      value: _vm.input.note,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "note", $$v)
                      },
                      expression: "input.note"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-6" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.hrm.message.tag") }
                  }),
                  _vm._v(" "),
                  _c("BaseInputTag", {
                    attrs: { disabled: _vm.disabled },
                    model: {
                      value: _vm.input.tags,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "tags", $$v)
                      },
                      expression: "input.tags"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showActionButtons
        ? _c("BaseFormAction", {
            attrs: {
              textCancel: _vm.$t("button.cancel"),
              textSubmit: _vm.$t("button.save"),
              isSubmitted: _vm.isSubmitted
            },
            on: { onCancel: _vm.handleCancel, onSubmit: _vm.handleSubmit }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dfa100f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dfa100f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/combine/HrmEmployeeForm.vue
// module id = null
// module chunks = 